<div class="cycle-navigation" *ngIf="cycleId$ | async as cycleId" data-test="cycle-navigation">
  <nav
    mat-tab-nav-bar
    [mat-stretch-tabs]="false"
    color="accent"
    *ngIf="!!cycleId"
    [tabPanel]="tabPanel"
  >
    <a mat-tab-link [routerLink]="['/cycle', cycleId]" [active]="isGeneral$ | async">
      {{ 'cycle-navigation.general' | translate }}
    </a>
    <a
      mat-tab-link
      [routerLink]="['/cycle', cycleId, 'day-old-chick']"
      [active]="isDayOldChick$ | async"
    >
      {{ 'cycle-navigation.day-old-chick' | translate }}
    </a>
    <a
      mat-tab-link
      [routerLink]="['/cycle', cycleId, 'departure']"
      [active]="isDeparture$ | async"
      >{{ 'cycle-navigation.departure' | translate }}</a
    >
    <a mat-tab-link [routerLink]="['/cycle', cycleId, 'balance']" [active]="isBalance$ | async">
      {{ 'cycle-navigation.balance' | translate }}
    </a>
    <a
      mat-tab-link
      [routerLink]="['/cycle', cycleId, 'discount']"
      *ngIf="canNavigate$ | async"
      [active]="isDiscount$ | async"
    >
      {{ 'discount-title' | translate }}
    </a>
    <a mat-tab-link [routerLink]="['/cycle', cycleId, 'closure']" [active]="isClosure$ | async">
      {{ 'otherCosts' | translate }}
    </a>
    <a
      mat-tab-link
      [routerLink]="['/cycle', cycleId, 'animal-group']"
      [active]="isAnimalGroup$ | async"
    >
      {{ 'animal-group.animalGroupTitle' | translate }}
    </a>
    <a
      mat-tab-link
      [routerLink]="['/cycle', cycleId, 'final-setup']"
      *ngIf="canNavigateFinalSetup$ | async"
      [active]="isFinalSetup$ | async"
    >
      {{ 'final-setup-setting.title' | translate }}
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
